
import { defineComponent, PropType } from 'vue'
import { Check, Run, ScaCheck } from '~/types/types'
import { gateStatusIcon } from '~/utils/ui'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'ReportCardView',
  props: {
    run: {
      type: Object as PropType<Run>,
      required: true
    }
  },
  computed: {
    checks(): Check[] {
      return resolveNodes(this.run.checks) ?? []
    },
    scaChecks(): ScaCheck[] {
      return resolveNodes(this.run.scaChecks) ?? []
    },
    provider(): string {
      return this.$route.params.provider
    },
    breadcrumbText(): string {
      if (this.run.isForDefaultBranch) {
        return this.run.commitMessage || this.run.commitOid?.substring(0, 7) || ''
      }
      return this.run.pullRequest?.title || this.run.pullRequestNumberDisplay || ''
    },
    badgeIcon(): string {
      return gateStatusIcon(this.run.status)
    }
  }
})
